import {
  CUSTOM_ERROR_HANDLERS_CREATOR,
  CustomErrorHandlersCreator,
  REFRESH_AND_TRY_AGAIN_ERROR_MESSAGE
} from '@aviary/interceptors/http-error-interceptor.types';
import {HttpContext} from '@angular/common/http';
import {SnackBarActions} from '@store/aviary/aviary.adapter';

export function contextWithErrorHandlerForMarkNotificationsAsRead(): HttpContext {
  const handler: CustomErrorHandlersCreator = () => ({
    400: {
      discardOriginalErrorResponse: false,
      actionMappers: [
        {
          // missing parameter for ids of notifications to mark read
          errorCodes: 'GENERAL_INVALID_VALUE',
          actions: SnackBarActions.showError('Please select notifications that you wish to mark as read and try again.')
        },
        {
          // authentication patron not found or requested notifications do not belong to authenticated patron
          errorCodes: 'PATRON_INVALID_ID',
          actions: SnackBarActions.showError(REFRESH_AND_TRY_AGAIN_ERROR_MESSAGE)
        }
      ]
    }
  });
  return new HttpContext().set(CUSTOM_ERROR_HANDLERS_CREATOR, handler);
}
